const { DateTime } = require("luxon");

const formatDateHoy = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return [year, month, day].join('-')
}

const formatMes = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return month;
}

const formatDateMonth = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return [year, month ].join('-')
}

const formatDateYear = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return [year].join('-')
}

const addMoreDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result
  }

const restDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() - days);
    return result
}

const formatDateHoyFromDate = (date) => {
    var d = addMoreDays(new Date(date),1),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return [year, month, day].join('-')
}

const formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

const configuracion_fechas = {
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric'
}

const configuracion_horas = {
    timeZone: 'America/Santiago',
    hour: '2-digit',
    minute: '2-digit'
}

const obtenerFechaZonaHorariaLocal = () => {
    const now = DateTime.now()
    now.setZone("America/Santiago")
    const fecha_local = now.toISO()
    return fecha_local
}

const obtenerFechaHoraZonaHorariaLocal = () => {
    const now = DateTime.now()
    // now.setZone(timezone)
    const fecha_local = now.toISO()
    return fecha_local
}

const obtenerRangos = (start, end) => {
    const fecha1 = formatDateHoy(start)
    const fecha2 = formatDateHoy(end)
    console.log({ fecha1, fecha2 })
    let desde = new Date(fecha1)
    let hasta = addMoreDays(fecha2,1)
    if(fecha1 === fecha2){
        desde = DateTime.fromISO(fecha1).startOf("day").toUTC().toISO()
        hasta = DateTime.fromISO(fecha1).endOf("day").toUTC().set({ minute: 58 }).toISO()
    } else {
        desde = DateTime.fromISO(fecha1).startOf("day").toUTC().toISO()
        hasta = DateTime.fromISO(fecha2).endOf("day").set({minute: 58 }).toUTC().toISO()
    }
    return { desde, hasta }
}

const formatTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = Math.round(minutes % 60);

    if (hours === 0 && remainingMinutes === 0) {
        return "Sin datos";
    } else if (hours === 0 && remainingMinutes < 1) {
        return "Menos de 1 Min.";
    } else if (hours === 0) {
        return `${remainingMinutes} Min.`;
    } else if (remainingMinutes === 0) {
        return `${hours} Hrs.`;
    } else {
        return `${hours} Hrs. ${remainingMinutes} Min.`;
    }
  }

module.exports = {
    obtenerFechaZonaHorariaLocal,
    formatDateHoy,
    formatMes,
    formatDateMonth,
    formatDateYear,
    addMoreDays,
    restDays,
    formatDate,
    configuracion_fechas,
    configuracion_horas,
    formatDateHoyFromDate,
    obtenerFechaHoraZonaHorariaLocal,
    obtenerRangos,
    formatTime
}